import DatasetDS from "../../../DataServices/DatasetDs";
import RequestSentDetailsDS from "../../../DataServices/RequestSentDetailsDS";
import AgenciesDS from "../../../DataServices/AgenciesDs";
import { useCustomContext } from "../../CustomComponents/CustomComponents";
import { insertLog } from "../../Logs/InsertLog";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
const TicketHistoryLogic = () => {
    const datasetDS = new DatasetDS();
    const requestSentDS = new RequestSentDetailsDS();
    const agenciesDS = new AgenciesDS();
    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];

    const [datasets, setDatasets] = useState([]);
    const [datasetID, setDatasetID] = useState("");
    const [agencies, setAgencies] = useState([]);
    const [agencyId, setAgencyId] = useState("");
    const [agencySearch, setAgencySearch] = useState("All Agencies");
    const [isAgencyDropdownOpen, setIsAgencyDropdownOpen] = useState(false);
    const [showAllAgencyOptions, setShowAllAgencyOptions] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [status, setStatus] = useState("call for status");
    const [appliedStatus, setAppliedStatus] = useState("call for status");
    const { showAlert, stopHudRotation, hud, showToast } = useCustomContext();

    const [ticketHistoryByPage, setTicketHistoryByPage] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMorePages, setHasMorePages] = useState(true);
    const [loadedPages, setLoadedPages] = useState([]);
    const [isPageSizeEnabled, setIsPageSizeEnabled] = useState(false);

    const [pageSize, setPageSize] = useState(25);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isRestored, setIsRestored] = useState(false);
    const [isFromDetails, setIsFromDetails] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const [filterErrors, setFilterErrors] = useState({});
    const [requestType, setRequestType] = useState("email");
    const [responseType, setResponseType] = useState("email");



    useEffect(() => {

        const restoreData = location.state?.ticketHistoryState;
        if (restoreData?.isFromDetails && !isRestored) {

            setIsFromDetails(true);

            setDatasetID(restoreData.datasetID);
            setAgencyId(restoreData.agencyId);
            setFromDate(restoreData.fromDate);
            setToDate(restoreData.toDate);
            setStatus(restoreData.status);
            setAppliedStatus(restoreData.status);
            setRequestType(restoreData.requestType);
            setResponseType(restoreData.responseType);
            setPageSize(restoreData.pageSize);
            setCurrentPage(restoreData.currentPage);

            setIsRestored(true);
            restoreTicketHistory(restoreData);


        }

    }, [location.state]);

    useEffect(() => {
        const restoreData = location.state?.ticketHistoryState;

        if (
            isFromDetails &&
            restoreData?.agencyId &&
            agencies.length > 0
        ) {
            setAgencyId(restoreData.agencyId);
        }
    }, [agencies, isFromDetails]);

    useEffect(() => {
        localStorage.removeItem('agencyDetailsPayload');
        fetchDatasets();

        const restoreData = location.state?.ticketHistoryState;
        if (restoreData?.isFromDetails) {
            return;
        }

        const today = new Date();
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(today.getDate() - 7);

        const formatDate = (date) => date.toISOString().split("T")[0];
        setToDate(formatDate(today));
        setFromDate(formatDate(sevenDaysAgo));

    }, []);

    useEffect(() => {
        if (datasetID) {
            fetchAgencieByDataset(datasetID);
        } else {
            setAgencies([]);
            setAgencyId("");
            setAgencySearch("All Agencies");
        }
    }, [datasetID]);


    const restoreTicketHistory = async (restoreData) => {

        const page = restoreData.currentPage;
        const limit = restoreData.pageSize;

        await loadTicketHistory(
            page,
            limit,
            {
                agencyId: restoreData.agencyId,
                datasetID: restoreData.datasetID,
                fromDate: restoreData.fromDate,
                toDate: restoreData.toDate,
                status: restoreData.status,
                requestType: restoreData.requestType,
                responseType: restoreData.responseType
            },
            true
        );
    };

    const fetchDatasets = async () => {
        try {
            const req = {};
            const response = await datasetDS.AP_Dataset_List_GET(req);

            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200 && Array.isArray(body.records)) {

                const accessLevel = localStorage.getItem('accessLevel');
                const isAdmin = accessLevel === '1';

                const allowedDatasets = JSON.parse(localStorage.getItem('winterSoldierDatasets') || '[]');

                const permittedDatasets = isAdmin
                    ? body.records
                    : body.records.filter(item => allowedDatasets.includes(item.datasetID)
                    );

                const requestDatasets = permittedDatasets.filter(item =>
                    // item.entryType === "Request Based PDF Entry" && item.datasetID === "NJ-103"
                    item.entryType === "Request Based PDF Entry"
                );
                setDatasets(requestDatasets);
            }
            else {
                showAlert(body?.message || "Failed to load Datasets.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch datasets`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'GET',
                'AP_Dataset_List_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Something went wrong while fetching Datasets.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
        }
    };

    const fetchAgencieByDataset = async (datasetID) => {
        try {
            const req = { datasetID };
            const response = await requestSentDS.WS_Agency_ByDatasetID_GET(req);

            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && Array.isArray(body.records)) {
                setAgencies(body.records);


            } else {
                showAlert(body?.message || "Failed to load Agencies.", [
                    { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
                ]);
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch agencies for dataset ${datasetID}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'GET',
                'WS_Agency_ByDatasetID_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Something went wrong while fetching Agencies.", [
                { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
            ]);
        }
    };


    const handleDatasetChange = async (e) => {
        const selectedDataset = e.target.value;

        setDatasetID(selectedDataset);
        setIsPageSizeEnabled(false);
        resetPagination();

        setAgencyId("");
        setAgencySearch("All Agencies");
        setIsAgencyDropdownOpen(false);
        setShowAllAgencyOptions(false);
        setAgencies([]);
    };

    const getAgencyLabel = (agency) =>
        `${agency.agencyID} - ${agency.agencyName}`;

    const selectedAgencyForFilter = agencies.find((agency) => agency.agencyID == agencyId);
    const selectedAgencyLabel = selectedAgencyForFilter
        ? getAgencyLabel(selectedAgencyForFilter)
        : "All Agencies";

    const agencySearchText = agencySearch === selectedAgencyLabel || agencySearch === "All Agencies"
        ? ""
        : agencySearch.trim().toLowerCase();

    const filteredAgencyOptions = showAllAgencyOptions
        ? agencies
        : agencySearchText
            ? agencies.filter((agency) =>
                getAgencyLabel(agency).toLowerCase().includes(agencySearchText)
            )
            : agencies;

    useEffect(() => {
        if (agencyId && selectedAgencyForFilter) {
            setAgencySearch(getAgencyLabel(selectedAgencyForFilter));
        }
    }, [agencyId, selectedAgencyForFilter]);

    const handleAgencySearchChange = (e) => {
        const value = e.target.value;
        setAgencySearch(value);
        setIsAgencyDropdownOpen(true);
        setShowAllAgencyOptions(false);

        if (agencyId) {
            setAgencyId("");
        }

        resetPagination();
    };

    const handleAgencyKeyDown = (e) => {
        if (e.key === "Enter" && filteredAgencyOptions.length > 0) {
            e.preventDefault();
            selectAgencyOption(filteredAgencyOptions[0]);
        }

        if (e.key === "Escape") {
            setIsAgencyDropdownOpen(false);
        }
    };

    const selectAllAgencies = () => {
        setAgencySearch("All Agencies");
        setIsAgencyDropdownOpen(false);
        setShowAllAgencyOptions(false);
        updateAgencySelection("");
    };

    const selectAgencyOption = (agency) => {
        setAgencySearch(getAgencyLabel(agency));
        setIsAgencyDropdownOpen(false);
        setShowAllAgencyOptions(false);
        updateAgencySelection(agency.agencyID);
    };

    const updateAgencySelection = (selectedAgencyID) => {
        setAgencyId(selectedAgencyID);
        setIsPageSizeEnabled(false);
        resetPagination();

        if (!selectedAgencyID) {
            setAgencySearch("All Agencies");
        }
    };


    const handleFromDateChange = (e) => {
        const selectedFromDate = e.target.value;
        setFromDate(selectedFromDate);
        setIsPageSizeEnabled(false);
        resetPagination();

    }

    const handleToDateChange = (e) => {
        const selectedtoDate = e.target.value;
        setToDate(selectedtoDate);
        setIsPageSizeEnabled(false);
        resetPagination();

    }

    const handleRequestTypeChange = (e) => {
        setRequestType(e.target.value);
        setIsPageSizeEnabled(false);
        resetPagination();
    };

    const handleResponseTypeChange = (e) => {
        setResponseType(e.target.value);
        setIsPageSizeEnabled(false);
        resetPagination();
    };

    const handleStatusChange = (e) => {
        setStatus(e.target.value);
        setIsPageSizeEnabled(false);
        resetPagination();
    };


    const resetPagination = () => {
        setCurrentPage(1);

        setTicketHistoryByPage({});

        setLoadedPages([]);

        setHasMorePages(true);

        setTotalRecords(0);

        setIsPageSizeEnabled(false);
    };

    const handleSearch = async (e) => {

        e.preventDefault();
        let effectiveAgencyId = agencyId;
        const enteredAgencyText = agencySearch.trim();

        if (!effectiveAgencyId && enteredAgencyText && enteredAgencyText.toLowerCase() !== "all agencies") {
            const exactAgencyMatch = agencies.find(
                (agency) => getAgencyLabel(agency).toLowerCase() === enteredAgencyText.toLowerCase()
            );

            if (exactAgencyMatch) {
                effectiveAgencyId = exactAgencyMatch.agencyID;
                setAgencyId(exactAgencyMatch.agencyID);
                setAgencySearch(getAgencyLabel(exactAgencyMatch));
            } else {
                showToast({ message: "Please select a valid agency from the dropdown" });
                resetPagination();
                return;
            }
        }

        // const errs = {};

        // if (!datasetID || datasetID === "Select Dataset") errs.datasetID = "Please select a Dataset";
        // if (!fromDate) errs.fromDate = "From Date is required";
        // if (!toDate) errs.toDate = "To Date is required";
        // if (!requestType) errs.requestType = "Request Method is required";
        // if (!responseType) errs.responseType = "Response Method is required";
        // if (!status || status === "") errs.status = "Status is required";

        // if (new Date(toDate) < new Date(fromDate)) errs.toDate = "To Date cannot be earlier than From Date";

        // setFilterErrors(errs);

        // if (Object.keys(errs).length > 0) return;


        if (!datasetID || datasetID === "Select Dataset") {
            showToast({
                message: "Please select a Dataset"
            });
            return;
        }

        if (!fromDate) {
            showToast({
                message: "Please select From Date"
            });
            return;
        }

        if (!toDate) {
            showToast({
                message: "Please select To Date"
            });
            return;
        }

        if (!status) {
            showToast({
                message: "Please select status"
            });
            return;
        }

        if (new Date(toDate) < new Date(fromDate)) {
            showToast({
                message:
                    "To Date cannot be earlier than From Date"
            });
            return;
        }

        if (!requestType) {
            showToast({
                message: "Please select Request Type "
            });
            return;
        }

        if (!responseType) {
            showToast({
                message: "Please select Response Type"
            });
            return;
        }
        setAppliedStatus(status);
        // reset pagination
        setCurrentPage(1);
        setTicketHistoryByPage({});
        setLoadedPages([]);
        setHasMorePages(true);
        setTotalRecords(0);
        await loadTicketHistory(
            1,
            pageSize,
            {
                agencyId: effectiveAgencyId,
                datasetID,
                fromDate,
                toDate,
                requestType,
                responseType,
                status
            },
            true
        );

    };

    const loadTicketHistory = async (pageNum = currentPage, limit = pageSize, restoredFilters = null, forceReload = false) => {

        // already loaded
        if (loadedPages.includes(pageNum) && !forceReload) {
            return;
        }

        hud("Please Wait..");
        try {
            const offset = (pageNum - 1) * limit;

            const filters = restoredFilters || {
                agencyId,
                datasetID,
                fromDate,
                toDate,
                requestType,
                responseType,
                status
            };
            const requestData = {
                agencyID: filters.agencyId,
                datasetID: filters.datasetID,
                fromDate: filters.fromDate,
                toDate: filters.toDate,
                status: filters.status,
                requestType: filters.requestType,
                responseType: filters.responseType,
                limit,
                offset
            };
            console.log("Payload", requestData);

            const response =
                await requestSentDS.WS_Agency_Ticket_History_GET(
                    requestData
                );

            const data = response.data;

            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;


            if (data.statusCode === 200 && Array.isArray(body.records)) {

                setTicketHistoryByPage(prev => ({
                    ...prev,
                    [pageNum]: body.records
                }));

                console.log("bodyRecords", body.records);

                setLoadedPages(prev =>
                    pageNum === 1
                        ? [pageNum]
                        : prev.includes(pageNum)
                            ? prev
                            : [...prev, pageNum]
                );

                setHasMorePages(
                    body.isMoreRecordsAvailable || false
                );

                setTotalRecords(
                    body.totalRecords || 0
                );
                setIsPageSizeEnabled(true);
            }
            else {
                showAlert(
                    "Failed to load ticket history",
                    [{
                        label: "OK",
                        onClick: () => { },
                        color: "var(--buttonColor)"
                    }]
                );

                insertLog(
                    `${userName} failed to fetch agency ticket history`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    '',
                    'GET',
                    'WS_Agency_Ticket_History_GET',
                    'FAILED',
                    'Failed to load ticket history'
                );
            }

        } catch (error) {

            showAlert(
                error.message || "Something went wrong",
                [{
                    label: "OK",
                    onClick: () => { },
                    color: "var(--buttonColor)"
                }]
            );
            insertLog(
                `${userName} failed to fetch agency ticket history`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'GET',
                'WS_Agency_Ticket_History_GET',
                'FAILED',
                error?.message || ''
            );

        } finally {

            stopHudRotation();
        }
    };

    const ticketHistory = ticketHistoryByPage[currentPage] || [];

    const totalPages = Math.ceil(totalRecords / pageSize);

    const startEntry = totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1;

    const endEntry = Math.min(currentPage * pageSize, totalRecords);

    const handlePreviousPage = async () => {

        if (currentPage === 1) {
            return;
        }

        const previousPage = currentPage - 1;

        setCurrentPage(previousPage);

        if (!ticketHistoryByPage[previousPage]) {

            await loadTicketHistory(
                previousPage,
                pageSize
            );
        }


    };

    const handleNextPage = async () => {

        if (currentPage === totalPages || ticketHistory.length === 0) {
            return;
        }

        const nextPage = currentPage + 1;

        setCurrentPage(nextPage);

        // API hit only if page not loaded
        if (!ticketHistoryByPage[nextPage]) {

            await loadTicketHistory(
                nextPage,
                pageSize
            );
        }
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                showToast({ message: `Request Id copied to clipboard!` });
            })
            .catch(() => {
                showToast({ message: "Failed to copy!" });
            });
    };

    const handlePageSizeChange = async (value) => {

        const newSize = Number(value);
        setPageSize(newSize);
        setCurrentPage(1);
        setTicketHistoryByPage({});
        setLoadedPages([]);
        setHasMorePages(true);
        setTotalRecords(0);

        await loadTicketHistory(
            1,
            newSize,
            null,
            true
        );
    };

    const handleRequestClick = async (req) => {

        try {

            hud("Please Wait...");

            const response =
                await requestSentDS.WS_OutgoingRequest_Details_GET({
                    requestID: req.requestID
                });

            const data = response.data;

            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            console.log("body", body);

            if (data.statusCode === 200) {
                const selectedDataset = datasets.find((ds) => ds.datasetID === (req.datasetID || datasetID));
                const requestDatasetName = body.requests?.datasetName || req.datasetName || selectedDataset?.datasetName || "";

                navigate(
                    `/TicketDetails?requestID=${req.requestID}`,
                    {
                        state: {
                            fullData: {
                                ...body,
                                requests: {
                                    ...(body.requests || {}),
                                    datasetID: body.requests?.datasetID || req.datasetID || datasetID,
                                    datasetName: requestDatasetName
                                }
                            },
                            ticketHistoryState: {
                                datasetID,
                                datasetName: requestDatasetName,
                                agencyId,
                                fromDate,
                                toDate,
                                requestType,
                                responseType,
                                status,
                                currentPage,
                                pageSize,
                                isFromDetails: true
                            }
                        }

                    }
                );

            } else {

                showAlert(
                    body?.message || "Failed to load request details",
                    [{
                        label: "OK",
                        onClick: () => { },
                        color: "var(--buttonColor)"
                    }]
                );
            }

        } catch (error) {

            showAlert(
                error.message || "Something went wrong",
                [{
                    label: "OK",
                    onClick: () => { },
                    color: "var(--buttonColor)"
                }]
            );

        } finally {

            stopHudRotation();
        }
    };

    const getAgencyRecordForDetailsNavigation = async (agency) => {
        const id = agency?._id || agency?.id;
        if (!id) return agency || null;

        hud("Please Wait...");
        try {
            const response = await agenciesDS.AP_Agency_ById_GET({ id });
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && body.record) {
                return body.record;
            }
        } catch (error) {
            console.warn("Unable to fetch full agency details before navigation", error);
        } finally {
            stopHudRotation();
        }

        return agency || null;
    };

    const getThreeMonthsAgoDate = () => {
        const date = new Date();
        date.setMonth(date.getMonth() - 3);
        return date.toISOString().split("T")[0];
    };

    return {
        datasets, datasetID, agencies, agencyId, agencySearch, isAgencyDropdownOpen, showAllAgencyOptions, filteredAgencyOptions, fromDate, toDate, status,
        handleDatasetChange, handleAgencySearchChange, handleAgencyKeyDown, selectAllAgencies, selectAgencyOption, setIsAgencyDropdownOpen, setShowAllAgencyOptions, getAgencyLabel, handleFromDateChange, handleToDateChange, handleStatusChange, handleSearch,
        ticketHistory, currentPage, totalPages, startEntry, endEntry, totalRecords, pageSize, setPageSize, handleNextPage, handlePreviousPage,
        handleCopy, hasMorePages, handlePageSizeChange, isPageSizeEnabled, handleRequestClick, minDate: getThreeMonthsAgoDate(),
        maxDate: new Date().toISOString().split("T")[0], filterErrors,
        setFilterErrors,
        requestType,
        setRequestType,
        responseType,
        setResponseType,
        handleRequestTypeChange,
        handleResponseTypeChange,
        appliedStatus,
        getAgencyRecordForDetailsNavigation,
        navigate
    };
};

export default TicketHistoryLogic;

